<template>
  <v-app>
    <template v-if="isAuthenticated">
      <TopBar @logout="handleLogout" />
      <SideNav 
        :client-menu-items="clientMenuItems"
        :filtered-clients="filteredClients"
      />
      <v-main :style="{ background: colors.NEUTRAL }">
        <router-view></router-view>
      </v-main>
    </template>

    <template v-else>
      <LoginView 
        :loading="loading"
        :colors="colors"
        @login="handleLogin"
      />
    </template> 
    <!-- todo aram i don't like the fact that the colors need to be passed down to the login view -->
  </v-app>
</template>

<script setup lang="ts">
import { ref, onMounted, provide } from 'vue'
import { useRouter } from 'vue-router'
import { msalInstance, loginRequest } from '@/auth/msalInstance'
import { api } from '@/services/api'
import type Client from '@/models/client'
import TopBar from '@/components/layout/TopBar.vue'
import SideNav from '@/components/layout/SideNav.vue'
import LoginView from '@/components/auth/LoginView.vue'

// Constants
const colors = {
  PRIMARY: '#714FE3',
  ACCENT: '#F29B00',
  NEUTRAL: '#FFFFFF',
  SECONDARY: ['#D0ED77', '#D284EF', '#39288C']
}

// Reactive state
const isAuthenticated = ref(false)
const loading = ref(false)
const clientMenuItems = ref<Client[]>([])
const searchQuery = ref('')
const filteredClients = ref<Client[]>([])
const menu = ref(false)
const router = useRouter()

// Authentication methods
const checkAuth = async () => {
  const accounts = msalInstance.getAllAccounts()
  isAuthenticated.value = accounts.length > 0
}

const handleLogin = async () => { // todo aram kinda wanna move this to the login view
  loading.value = true
  console.log("redirectUri from window:", window.location.origin);
  try {
    await msalInstance.loginPopup(loginRequest)
    await checkAuth()
    const redirectPath = sessionStorage.getItem('redirectPath') || '/'
    console.log("redirectPath:", redirectPath);
    sessionStorage.removeItem('redirectPath')
    router.push(redirectPath)
  } catch (error) {
    console.error('Login failed:', error)
  } finally {
    loading.value = false
  }
}

const handleLogout = async () => {
  loading.value = true;
  try {
    await msalInstance.logoutPopup();
    isAuthenticated.value = false;
    router.push('/login');
  } catch (error) {
    console.error('Logout failed:', error);
  } finally {
    loading.value = false;
  }
};

// Methods
const filterClients = () => {
  filteredClients.value = clientMenuItems.value.filter(client =>
    client.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
}

const selectClient = (client: Client) => {
  menu.value = false;
  router.push(`/client/${client.id}`);

  setTimeout(() => {
    filteredClients.value = clientMenuItems.value;
    searchQuery.value = '';
  }, 300);
}

const showActivityHistory = () => {
  router.push('/activity-history')
}

const getClients = async () => {
  try {
    const clients = await api.getClients() as Client[]
    clientMenuItems.value = clients
    filteredClients.value = clients
    console.log('Clients:', clients)
  } catch (error) {
    console.error('Error fetching clients:', error)
  }
}

// Lifecycle hooks
onMounted(async () => {
  await checkAuth()
  if (isAuthenticated.value) {
    filteredClients.value = clientMenuItems.value
    getClients()
  }
})

// Make getClients available to child components
provide('refreshClients', getClients)
</script>

<style scoped>
.v-navigation-drawer {
  padding-bottom: 72px; /* Increased to accommodate more bottom margin */
}

.activity-history-button {
  position: absolute;
  bottom: 24px; /* Increased from 8px to 16px for more bottom margin */
  left: 8px;
  right: 8px;
}
</style>
